
import { defineComponent, reactive, toRefs, watchEffect, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { toResult } from '@/utils/toResult'
import { save } from './api'
import { useEnterpriseRemote } from '../enterprise-remote'
import { required } from '@/utils/rules'

export default defineComponent({
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  emits: ['update:modelValue', 'onSuccess'],
  setup(props, { emit }) {
    const rules = {
      companyUuid: [required],
      businessType: [required],
      quota: [required],
      expireTime: [required]
    }
    // 批次起始默认当天（00:00:00），批次到期默认一年后的当天（23:59:59）
    const defaultFormData = () => {
      const fmt = (d: Date, time: string) => {
        const pad = (n: number) => String(n).padStart(2, '0')
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${time}`
      }
      const now = new Date()
      const nextYear = new Date(now)
      nextYear.setFullYear(now.getFullYear() + 1)
      return {
        startTime: fmt(now, '00:00:00'),
        expireTime: fmt(nextYear, '23:59:59')
      }
    }

    const remoteData1 = useEnterpriseRemote()
    const data = reactive({
      visible: false,
      formRef: undefined,
      formData: ref<any>(defaultFormData())
    })

    watchEffect(() => {
      data.visible = props.modelValue
    })

    // 关闭动画结束后再通知父组件卸载，避免 Teleport DOM 被提前移除
    const onClosed = (): void => {
      emit('update:modelValue', false)
      emit('onSuccess')
    }

    const handleCancel = (): void => {
      data.visible = false
    }

    const handleSubmit = () => {
      data.formRef.validate(async (valid) => {
        if (valid) {
          const p = { ...data.formData }
          const [err] = await toResult(save(p))
          if (err) return false
          ElMessage.success('新增成功')
          data.visible = false
        }
      })
    }

    return {
      ...toRefs(data),
      handleSubmit,
      handleCancel,
      onClosed,
      remoteData1,
      rules
    }
  }
})
